import styled from "styled-components"
import Dropzone from "react-dropzone"

interface Props {
  width?: string
  height?: string
}

export default styled(Dropzone)<Props>`
  ${({width, height}) => `
    width: ${width || "100%"};
    height: ${height || "250px"};
  `}
  margin-bottom: ${({theme}) => theme.spacing.four};
  border-width: 2px;
  border-color: #666;
  border-style: dashed;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 15px;
`
